import { useEffect } from 'react';

import { logWBLaunchV2Info } from '@/features/logging/action-logger';

export const useIosBridgeLoader = () => {
  useEffect(() => {
    window.togglePaytable = () => {
      window.postMessage(
        {
          type: 'GL/TOGGLE_PAYTABLE',
        },
        '*',
      );
    };

    window.toggleBalanceUpdate = (oldBalanceValue) => {
      window.postMessage(
        {
          type: 'GL/RELOAD_BALANCE',
          payload: oldBalanceValue,
        },
        '*',
      );
    };

    window.toggleHowToPlay = () => {
      window.postMessage(
        {
          type: 'GL/TOGGLE_HELP',
        },
        '*',
      );
    };

    window.toggleSoundOff = () => {
      window.postMessage(
        {
          type: 'GL/TOGGLE_AUDIO',
          payload: false,
        },
        '*',
      );
    };

    window.toggleSoundOn = () => {
      window.postMessage(
        {
          type: 'GL/TOGGLE_AUDIO',
          payload: true,
        },
        '*',
      );
    };

    window.triggerErrorMessageDismissed = () => {
      window.postMessage(
        {
          type: 'GL/DISMISS_ERROR',
        },
        '*',
      );
    };

    window.triggerAutoSpinStop = () => {
      window.postMessage(
        {
          type: 'GL/AUTO_SPIN_STOP',
        },
        '*',
      );
    };

    window.triggerCloseGame = (type: string) => {
      try {
        window.postMessage(
          {
            type,
            payload: true,
          },
          '*',
        );
      } catch (error) {
        logWBLaunchV2Info('Cannot post message to GC');
      }

      window?.webkit?.messageHandlers.closeGameReceived.postMessage(
        'closeGame',
      );
    };

    window.triggerStopAutoSpin = () => {
      window.postMessage(
        {
          type: 'GL/AUTO_SPIN_STOP',
        },
        '*',
      );
    };

    window.triggerResumeAutoSpin = () => {
      window.postMessage(
        {
          type: 'GL/AUTO_SPIN_RESUME',
        },
        '*',
      );
    };

    window.chooseDialog = (choice) => {
      try {
        window.postMessage(
          {
            type: 'GL/FREE_SPINS_DIALOG',
            payload: choice,
          },
          '*',
        );
      } catch (error) {
        logWBLaunchV2Info('Cannot post message to GC');
      }
    };

    /*
     Payload for handshake:
     [
     "initializeGameParams" : ...
     ] 
     */

    window.triggerHandshake = (payload) => {
      window.postMessage(
        {
          type: 'GL/INITIALIZE_HANDSHAKE_PARAMS',
          payload,
        },
        '*',
      );

      logWBLaunchV2Info('Dispatching handshake init message event - V2');
    };

    window.triggerGeolocation = (payload) => {
      logWBLaunchV2Info('Dispatching geolocationResult event - V2');

      window.postMessage(
        {
          type: 'GL/GEOLOCATION_RESULT',
          payload,
        },
        '*',
      );
    };

    window.triggerAccountTokenRenewal = (payload) => {
      logWBLaunchV2Info('Dispatching authentication token update event');

      window.postMessage(
        {
          type: 'GL/AUTHENTICATION_TOKEN_UPDATE',
          payload,
        },
        '*',
      );
    };

    window.triggerSoftReload = () => {
      window.postMessage(
        {
          type: 'GL/IOS_SOFT_RELOAD',
        },
        '*',
      );

      logWBLaunchV2Info('Dispatching soft reload message event - V3');
    };

    window.triggerGameURL = (payload) => {
      window.postMessage(
        {
          type: 'GL/INITIALIZE_URL',
          payload,
        },
        '*',
      );

      logWBLaunchV2Info('Dispatching initialize using game URL - V3');
    };

    window.sendGameWindowEnabled = (payload) => {
      const options = { targetOrigin: '*' };
      window.postMessage(
        {
          type: 'GL/GAME_WINDOW_UI_ENABLED',
          payload,
        },
        options,
      );

      logWBLaunchV2Info('Dispatching sendGameWindow state event message - V3');
    };

    return () => {
      delete window.togglePaytable;
      delete window.toggleBalanceUpdate;
      delete window.toggleHowToPlay;
      delete window.toggleSoundOff;
      delete window.toggleSoundOn;
      delete window.triggerErrorMessageDismissed;
      delete window.triggerGameURL;
      delete window.triggerAutoSpinStop;
      delete window.triggerCloseGame;
      delete window.triggerStopAutoSpin;
      delete window.triggerResumeAutoSpin;
      delete window.chooseDialog;
      delete window.triggerAccountTokenRenewal;
      delete window.triggerSoftReload;
      delete window.sendGameWindowEnabled;
    };
  }, []);
};
